import { WFSectionLocalResource } from 'src/app/components/workflow/workflow';


export class DeletedSectionsRefresh {
  static readonly type = '[DeletedSections] Refresh';
  constructor(public checklistTemplateID: number) { }
}
